export default __webpack_public_path__ + "static/media/instagram.67c55964.svg";